import { render, staticRenderFns } from "./PortfolioProjectDetails.vue?vue&type=template&id=0566d60b&"
import script from "./PortfolioProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./PortfolioProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports